<template src="./html/events-quiz.html"></template>

<script>
import { quizFunctions } from "../components/functions";
import moreInfoForm from '../components/more-info-form.vue';
import globalMixin from '../mixins/global';

let quiz = {
    questions: [{
      text: "The most rewarding thing about competition is...",
      responses: [{
          text: 'Challenging and surpassing my peers.',
          value: '0'
        },
        {
          text: 'Building on my past accomplishments.',
          value: '1'
        },
        {
          text: 'Achieving and sharing success as a team.',
          value: '2'
        },
        {
          text: 'Honing my own skills and expertise.',
          value: '3'
        }
      ],
      image: require('../assets/learner-quiz-Moose-Q1.png')
      ,
    },
    {
      text: "The greatest kinds of awards are...",
      responses: [{
          text: 'Those that are widely recognized and show how I’m ranking in my industry or against peers.',
          value: '0'
        },
        {
          text: 'Those that are more specialized and unique, even if they aren’t as well&nbsp;known.',
          value: '1,3'
        },
        {
          text: 'Those that I earned as part of a group and can share with my network.',
          value: '2'
        }
      ],
      image: require('../assets/learner-quiz-Moose-Q2.png'),
    },
    {
      text: "I do my best learning...",
      responses: [{
          text: 'As part of a group.',
          value: '2'
        },
        {
          text: '1:1',
          value: '0,1'
        },
        {
          text: 'On my own.',
          value: '3'
        }
      ],
      image: require('../assets/learner-quiz-Moose-Q3.png'),
    },
    {
    text: "Learning should...",
      responses: [{
          text: 'Have clear and defined paths.',
          value: '0,1'
        },
        {
          text: 'Set clear frameworks but let me explore if I need to.',
          value: '2'
        },
        {
          text: 'Be a choose your own adventure.',
          value: '3'
        }
      ],
      image: require('../assets/learner-quiz-Moose-Q4.png')
      ,
    },
    {
      text: "I want to build up my expertise so I can...",
      responses: [
        {
          text: 'Strive to be top of the class.',
          value: '0'
        },
        {
          text: 'Challenge myself to keep doing better.',
          value: '1'
        },
        {
          text: 'Contribute to the collective knowledge.',
          value: '2'
        },
        {
          text: 'Distinguish myself as a subject matter expert.',
          value: '3'
        }
      ],
      image: require('../assets/learner-quiz-Moose-Q5.png')
      ,
    },
  ]
};

let types_content = {

    sections: [
      {
        section_title: 'Competitor',
        hovered_content: 'Fueled by competition',
        background_colour: 'color-cinnabar',
        text_colour: 'd2lWhite',
        image: require('../assets/learner-quiz-Competitor.png'),
        knockout_image: require('../assets/learner-quiz-Competitor-Shadow.png'),
        social_description: 'I\'m a Competitor! Find out your learner type here.',
        winner_content: 'You thrive on competition. For you, being able to rank your knowledge and skills development against external benchmarks like peer performance or industry averages provides the greatest source of fulfillment and motivation.',
        download_pdf: '',
        section_attributes: [
          'Setting and raising the bar',
          'Striving to lead the pack',
          'Leaderboards, awards, badges, and newsfeeds'
        ]
      },
      {
        section_title: 'Collector',
        hovered_content: 'Driven by achievements',
        background_colour: 'color-fluorite',
        text_colour: 'd2lWhite',
        image: require('../assets/learner-quiz-Collector.png'),
        knockout_image: require('../assets/learner-quiz-Collector-Shadow.png'),
        social_description: 'I\'m a Collector! Find out your learner type here.',
        winner_content: 'You love a challenge, but your opponents are your own past achievements. Your goal is to do better than you did last time and earn a trove of awards, even if they don\'t garner as much public attention.',
        download_pdf: '',
        section_attributes: [
          'Uncovering hidden gems',
          'Growing your collection of unique, specialized distinctions',
          'Awards, badges, and personalized learning'
        ]
      },
      {
        section_title: 'Collaborator',
        hovered_content: 'Inspired by other learners',
        background_colour: 'color-celestine',
        text_colour: 'd2lWhite',
        image: require('../assets/learner-quiz-Collaborator.png'),
        knockout_image: require('../assets/learner-quiz-Collaborator-Shadow.png'),
        social_description: 'I\'m a Collaborator! Find out your learner type here.',
        winner_content: 'You shine when you can interact as part of a community. You look for opportunities to share your expertise and play active roles in helping and encouraging peers to advance their own and the collective skills and knowledge.',
        download_pdf: '',
        section_attributes: [
          'Encouraging knowledge sharing among individuals and groups',
          'Contributing to the collective knowledge',
          'Newsfeeds, discussions, and feedback'
        ]
      },
      {
        section_title: 'Connoisseur',
        hovered_content: 'Motivated by expertise',
        background_colour: 'color-malachite',
        text_colour: 'color-onyx',
        image: require('../assets/learner-quiz-Connoisseur.png'),
        knockout_image: require('../assets/learner-quiz-Connoisseur-Shadow.png'),
        social_description: 'I\'m a Connoisseur! Find out your learner type here.',
        winner_content: 'You flourish when you can become the master of your own domain. You prize being able to guide your own journey, dig deep and thoroughly understand the subjects you’re interested in, and set yourself apart as the expert.',
        download_pdf: '',
        section_attributes: [
          'Developing in-depth, specialized knowledge',
          'Distinguishing yourself as a subject matter expert',
          'Personalized, self-led learning and feedback tools'
        ]
      }
    ]
};

export default {
  name: 'learner-type-quiz',

  components: {
    moreInfoForm
  },

  mixins: [quizFunctions, globalMixin],
  
  data() {
    return {
      ...this.defaultQuizData(),
      ...{
        attributes_data: [
          {
            heading: 'Strength',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="color-green-60_icon" d="M53,50H52a2,2,0,0,1-2-2V16A1.94,1.94,0,0,1,52,14L53,14a2,2,0,0,1,2,2V48A2,2,0,0,1,53,50Z"></path><rect class="color-green-60_icon" x="55.02" y="24" width="5" height="18" rx="2"></rect><rect class="color-green-60_icon" x="14.02" y="31" width="7" height="5"></rect><rect class="color-green-60_icon" x="43.02" y="31" width="7" height="5"></rect><path class="color-green-60_icon" d="M26.52,37V29A2.76,2.76,0,1,1,32,29v0a2.76,2.76,0,1,1,5.5,0v0A2.76,2.76,0,1,1,43,29V40c0,6.11-3.28,6-10,6s-12,.11-12-6V29c0-1.68.77-3,2.7-3a2.93,2.93,0,0,1,2.8,3v8"></path><path class="color-green-60_icon" d="M35,26V25c0-1.53.32-3,2-3h3v4"></path><path class="color-green-60_icon" d="M11,50h1a2,2,0,0,0,2-2V16a1.93,1.93,0,0,0-1.94-2L11,14a2,2,0,0,0-2,2V48A2,2,0,0,0,11,50Z"></path><rect class="color-green-60_icon" x="4.02" y="24" width="5" height="18" rx="2"></rect></svg>'
          },
          {
            heading: 'Motivator',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path class="color-green-60_icon" d="M31.58,30.54A8.15,8.15,0,1,1,29.5,32.7"></path><path class="color-green-60_icon" d="M26.1,25.49A15.43,15.43,0,1,1,24,27.73"></path><path class="color-green-60_icon" d="M20.85,20.3a22.77,22.77,0,1,1-2.21,2.32"></path><polyline class="color-green-60_icon" points="3 11 9 11 9 4 12.92 8.02 17 12 17 17 37 36 35 37 15 19 9 19 5 15"></polyline></svg>'
          },
          {
            heading: 'Top Tools',
            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><polyline class="color-green-60_icon" points="41 29 48 22 53 22 60 8 56 4 42 11 42 16 35 23"></polyline><line class="color-green-60_icon" x1="27" y1="43" x2="29" y2="41"></line><line class="color-green-60_icon" x1="23" y1="35" x2="21" y2="37"></line><path class="color-green-60_icon" d="M16,60l9-9-2-4,6-2L19,35l-2,6-4-2L4,48v6c0,1.87,4.13,6,6,6Z"></path><line class="color-green-60_icon" x1="59" y1="52" x2="52" y2="59"></line><rect class="color-green-60_icon" x="33.76" y="16.79" width="8.49" height="42.43" transform="translate(-15.74 38) rotate(-45)"></rect><rect class="color-green-60_icon" x="11.26" y="4.89" width="8.49" height="21.21" transform="translate(-6.42 15.5) rotate(-45)"></rect><polyline class="color-green-60_icon" points="14 8 18 4 29 15"></polyline></svg>'
          }
        ]
      }
    }
  },

  methods: {
    defaultQuizData: function () {
      return {
        name:'learner-type',
        title: 'What\'s Your Learner Type?',
        share_description: 'Complete this quiz to find out what your learner type is!',
        active_image_default: require('../assets/learner-quiz-QuestionMark.png'),
        active_image: require('../assets/learner-quiz-QuestionMark.png'),
        active_section: '-1',
        active_colour_default: 'd2lOrange',
        active_colour: 'd2lOrange',
        winning_colour: '',
        winning_text_colour: '',
        winning_image: '',
        winning_title: '',
        winning_attributes: [],
        content_display: '',
        quiz_hidden: true,
        quiz: quiz,
        questionIndex: 0,
        userResponses: Array(),
        homepage_hidden: false,
        types: types_content,
        showForm: false,
        form_text: `Get your full results and claim your swag.`,
        form_thank_you_message: `Thank you! Come by the D2L booth and show this screen to claim your swag.`,
        button_text: '',
        form_id: '2042',
        salesforce_id: '7015W0000008xbaQAA'
      }
    }
  },

  created() {
    if ( this.isFusion() ) {
      this.form_text = `Fill out the form to get your full results.`;
      this.form_thank_you_message = `
       <p>An email with the information about your learner type will land in your inbox shortly.</p>
       <p>You can now close this dialog. If you wish to return to this screen simply click "Get my results" from the quiz.</p>
       <p class="h3 margin-top-2 text-center">Fusion Challenge Code: <span class="font-bold">QZ64</span></p>
      `;
    }

    if (this.isISTE_2024) {
      this.form_thank_you_message = `
        <p>Show this screen to a D2Ler to receive your Learner Type sticker.<p>
        </p>It is safe to close this dialog. You can return to this screen by clicking "Get my results"</p>
      `;
    }
  }
}
</script>

<style scoped>
.learner-type-container:before {
  content: "";
  background: var(--color-green);
  position: fixed;
  width: 20px;
  bottom: 0;
  top: 0;
  right:0 ;
  transform: scaleX(-1);
}

.home-image-wrap {
  height: 300px;
  max-height: 300px;
}

@media (min-width: 769px) {
  .learner-type-container:before {
    width: 60px;
  }
}

@media (max-width: 768px) {
  #results-container {
    flex-direction: column-reverse;
  }
  #results-main-content {
    flex-direction: column-reverse;
  }
  #attribute-list li>div {
    flex-direction: column;
  }
}
</style>
